import { render } from "./EmptyMessage.vue?vue&type=template&id=2721331e&scoped=true"
import script from "./EmptyMessage.vue?vue&type=script&lang=js"
export * from "./EmptyMessage.vue?vue&type=script&lang=js"

import "./EmptyMessage.vue?vue&type=style&index=0&id=2721331e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2721331e"]])

export default __exports__